import { render, staticRenderFns } from "./message.vue?vue&type=template&id=c6c6e656&scoped=true"
import script from "./message.vue?vue&type=script&lang=js"
export * from "./message.vue?vue&type=script&lang=js"
import style0 from "./message.vue?vue&type=style&index=0&id=c6c6e656&prod&lang=less&scoped=true"
import style1 from "./message.vue?vue&type=style&index=1&id=c6c6e656&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6c6e656",
  null
  
)

export default component.exports